/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as OrganizationKeyDossierIdResearchProjectIdRouteImport } from './routes/$organizationKey/$dossierId/$researchProjectId'
import { Route as OrganizationKeyDossierIdResearchProjectIdIndexRouteImport } from './routes/$organizationKey/$dossierId/$researchProjectId/index'
import { Route as OrganizationKeyDossierIdResearchProjectIdWizardRouteImport } from './routes/$organizationKey/$dossierId/$researchProjectId/wizard'
import { Route as OrganizationKeyDossierIdResearchProjectIdResultsIdRouteImport } from './routes/$organizationKey/$dossierId/$researchProjectId/results.$id'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationKeyDossierIdResearchProjectIdRoute =
  OrganizationKeyDossierIdResearchProjectIdRouteImport.update({
    id: '/$organizationKey/$dossierId/$researchProjectId',
    path: '/$organizationKey/$dossierId/$researchProjectId',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationKeyDossierIdResearchProjectIdIndexRoute =
  OrganizationKeyDossierIdResearchProjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OrganizationKeyDossierIdResearchProjectIdRoute,
  } as any)
const OrganizationKeyDossierIdResearchProjectIdWizardRoute =
  OrganizationKeyDossierIdResearchProjectIdWizardRouteImport.update({
    id: '/wizard',
    path: '/wizard',
    getParentRoute: () => OrganizationKeyDossierIdResearchProjectIdRoute,
  } as any)
const OrganizationKeyDossierIdResearchProjectIdResultsIdRoute =
  OrganizationKeyDossierIdResearchProjectIdResultsIdRouteImport.update({
    id: '/results/$id',
    path: '/results/$id',
    getParentRoute: () => OrganizationKeyDossierIdResearchProjectIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$organizationKey/$dossierId/$researchProjectId': typeof OrganizationKeyDossierIdResearchProjectIdRouteWithChildren
  '/$organizationKey/$dossierId/$researchProjectId/wizard': typeof OrganizationKeyDossierIdResearchProjectIdWizardRoute
  '/$organizationKey/$dossierId/$researchProjectId/': typeof OrganizationKeyDossierIdResearchProjectIdIndexRoute
  '/$organizationKey/$dossierId/$researchProjectId/results/$id': typeof OrganizationKeyDossierIdResearchProjectIdResultsIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$organizationKey/$dossierId/$researchProjectId/wizard': typeof OrganizationKeyDossierIdResearchProjectIdWizardRoute
  '/$organizationKey/$dossierId/$researchProjectId': typeof OrganizationKeyDossierIdResearchProjectIdIndexRoute
  '/$organizationKey/$dossierId/$researchProjectId/results/$id': typeof OrganizationKeyDossierIdResearchProjectIdResultsIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$organizationKey/$dossierId/$researchProjectId': typeof OrganizationKeyDossierIdResearchProjectIdRouteWithChildren
  '/$organizationKey/$dossierId/$researchProjectId/wizard': typeof OrganizationKeyDossierIdResearchProjectIdWizardRoute
  '/$organizationKey/$dossierId/$researchProjectId/': typeof OrganizationKeyDossierIdResearchProjectIdIndexRoute
  '/$organizationKey/$dossierId/$researchProjectId/results/$id': typeof OrganizationKeyDossierIdResearchProjectIdResultsIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$organizationKey/$dossierId/$researchProjectId'
    | '/$organizationKey/$dossierId/$researchProjectId/wizard'
    | '/$organizationKey/$dossierId/$researchProjectId/'
    | '/$organizationKey/$dossierId/$researchProjectId/results/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$organizationKey/$dossierId/$researchProjectId/wizard'
    | '/$organizationKey/$dossierId/$researchProjectId'
    | '/$organizationKey/$dossierId/$researchProjectId/results/$id'
  id:
    | '__root__'
    | '/'
    | '/$organizationKey/$dossierId/$researchProjectId'
    | '/$organizationKey/$dossierId/$researchProjectId/wizard'
    | '/$organizationKey/$dossierId/$researchProjectId/'
    | '/$organizationKey/$dossierId/$researchProjectId/results/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  OrganizationKeyDossierIdResearchProjectIdRoute: typeof OrganizationKeyDossierIdResearchProjectIdRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationKey/$dossierId/$researchProjectId': {
      id: '/$organizationKey/$dossierId/$researchProjectId'
      path: '/$organizationKey/$dossierId/$researchProjectId'
      fullPath: '/$organizationKey/$dossierId/$researchProjectId'
      preLoaderRoute: typeof OrganizationKeyDossierIdResearchProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationKey/$dossierId/$researchProjectId/': {
      id: '/$organizationKey/$dossierId/$researchProjectId/'
      path: '/'
      fullPath: '/$organizationKey/$dossierId/$researchProjectId/'
      preLoaderRoute: typeof OrganizationKeyDossierIdResearchProjectIdIndexRouteImport
      parentRoute: typeof OrganizationKeyDossierIdResearchProjectIdRoute
    }
    '/$organizationKey/$dossierId/$researchProjectId/wizard': {
      id: '/$organizationKey/$dossierId/$researchProjectId/wizard'
      path: '/wizard'
      fullPath: '/$organizationKey/$dossierId/$researchProjectId/wizard'
      preLoaderRoute: typeof OrganizationKeyDossierIdResearchProjectIdWizardRouteImport
      parentRoute: typeof OrganizationKeyDossierIdResearchProjectIdRoute
    }
    '/$organizationKey/$dossierId/$researchProjectId/results/$id': {
      id: '/$organizationKey/$dossierId/$researchProjectId/results/$id'
      path: '/results/$id'
      fullPath: '/$organizationKey/$dossierId/$researchProjectId/results/$id'
      preLoaderRoute: typeof OrganizationKeyDossierIdResearchProjectIdResultsIdRouteImport
      parentRoute: typeof OrganizationKeyDossierIdResearchProjectIdRoute
    }
  }
}

interface OrganizationKeyDossierIdResearchProjectIdRouteChildren {
  OrganizationKeyDossierIdResearchProjectIdWizardRoute: typeof OrganizationKeyDossierIdResearchProjectIdWizardRoute
  OrganizationKeyDossierIdResearchProjectIdIndexRoute: typeof OrganizationKeyDossierIdResearchProjectIdIndexRoute
  OrganizationKeyDossierIdResearchProjectIdResultsIdRoute: typeof OrganizationKeyDossierIdResearchProjectIdResultsIdRoute
}

const OrganizationKeyDossierIdResearchProjectIdRouteChildren: OrganizationKeyDossierIdResearchProjectIdRouteChildren =
  {
    OrganizationKeyDossierIdResearchProjectIdWizardRoute:
      OrganizationKeyDossierIdResearchProjectIdWizardRoute,
    OrganizationKeyDossierIdResearchProjectIdIndexRoute:
      OrganizationKeyDossierIdResearchProjectIdIndexRoute,
    OrganizationKeyDossierIdResearchProjectIdResultsIdRoute:
      OrganizationKeyDossierIdResearchProjectIdResultsIdRoute,
  }

const OrganizationKeyDossierIdResearchProjectIdRouteWithChildren =
  OrganizationKeyDossierIdResearchProjectIdRoute._addFileChildren(
    OrganizationKeyDossierIdResearchProjectIdRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  OrganizationKeyDossierIdResearchProjectIdRoute:
    OrganizationKeyDossierIdResearchProjectIdRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
